import {useForm, UseFormReturn} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';

import {domainMonitorAPI} from 'features/domain/api/domainMonitorAPI';
import {
    buildDomainIncidentTypeOptions,
    buildDomainMonitorOptions,
    getDomainIncidentsFiltersDefaults,
    SEARCHABLE_FROM_OPTIONS_COUNT,
} from 'features/domain/lib/domainIncidentsFiltersView';
import {
    DOMAIN_INCIDENTS_ORDER_FIELDS,
    getDomainIncidentFilters,
} from 'features/domain/lib/domainFilters';
import IDomainIncidentFilters from 'features/domain/model/DomainIncident/IDomainIncidentFilters';
import IOrderBy from 'shared/model/IOrderBy';
import {useSort} from 'shared/lib/hooks/useSort';

import {IDomainIncidentsFiltersForm} from './DomainIncident/IDomainIncidentsFiltersForm';

export interface IUseDomainIncidentsFiltersForm {
    form: UseFormReturn<IDomainIncidentsFiltersForm>,
    filters: IDomainIncidentFilters,
    sort: IOrderBy | undefined,
    domainMonitorOptions: ReturnType<typeof buildDomainMonitorOptions>,
    typeOptions: ReturnType<typeof buildDomainIncidentTypeOptions>,
    isMonitorSearchable: boolean,
}

export const useDomainIncidentsFiltersForm = (): IUseDomainIncidentsFiltersForm => {
    const [searchParams] = useSearchParams();
    const filters = getDomainIncidentFilters(searchParams);
    const [sort] = useSort({sortFields: DOMAIN_INCIDENTS_ORDER_FIELDS});

    const {data: domainMonitors} = domainMonitorAPI.useGetDomainMonitorsQuery({});

    const domainMonitorOptions = buildDomainMonitorOptions(domainMonitors?.items);

    const form = useForm<IDomainIncidentsFiltersForm>({
        mode: 'onSubmit',
        defaultValues: getDomainIncidentsFiltersDefaults(filters),
    });

    return {
        form,
        filters,
        sort,
        domainMonitorOptions,
        typeOptions: buildDomainIncidentTypeOptions(),
        isMonitorSearchable: domainMonitorOptions.length > SEARCHABLE_FROM_OPTIONS_COUNT,
    };
};

export default useDomainIncidentsFiltersForm;
